import React, { useRef } from "react";
import Button from "./Button";
import FileIcon from "../assets/img/file.svg";
import Trash from "../assets/img/trash.svg";
import { fireWrongExtention } from "../utils/swals";
/* const FileButton = ({ name }) => {
  <button>
    <span>{name}</span>
  </button>;
}; */

const FileUpload = ({ name, accepts, setFile, file }) => {
  const ref = useRef(null);
  const validExtensions = [".pdf", ".jpg", ".jpeg", ".png", ".doc", ".docx"];

  const handleFileInputClick = (e) => {
    e.preventDefault();
    ref.current.click();
  };


  return (
    <>
      <input
        type="file"
        ref={ref}
        className="d-none"
        name={name}
        onChange={(event) => {
          const selectedFile = event.target.files[0];

          if (selectedFile) {
            const fileExtension = selectedFile.name
              .split(".")
              .pop()
              .toLowerCase();

            if (!validExtensions.includes(`.${fileExtension}`)) {
              fireWrongExtention();
              return; // Stop processing if the file is invalid
            }

            setFile(selectedFile); // Set the valid file
          }
        }}
        accept="image/*, application/pdf, .doc, .docx"
        />
      <label
        htmlFor={name}
        className="file-upload"
        onClick={handleFileInputClick}
      >
        <img src={FileIcon} alt="Cargar archivo" />
        <p>
          Cargá acá tu/s archivo/s <br />
          en formato .pdf .jpg .png o .doc
        </p>
        {file ? (
          <div className="otro-archivo">
            <p>Subir otro archivo</p>
            <button type="button" className="file-button">
              <span>{file.name}</span>
              <img src={Trash} alt="Borrar" />
            </button>
          </div>
        ) : (
          <Button variant={"outline-btn"} style={{ alignSelf: "none" }}>
            Subir archivo
          </Button>
        )}
      </label>
    </>
  );
};

export default FileUpload;
